"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gargnano": {
    "6cd32a6e": [{
      "hkey": "034a9bc0",
      "slug": "bogliaco-villavetro",
      "name": "Bogliaco-Villavetro",
      "primary": true,
      "skipSearch": false
    }],
    "bogliaco": [{
      "hkey": "034a9bc0",
      "slug": "bogliaco-villavetro",
      "name": "Bogliaco-Villavetro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a8aa7a75": [{
      "hkey": "6a93ce3e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "6a93ce3e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gargnano"
    }],
    "cda6f5ea": [{
      "hkey": "034a9bc0",
      "slug": "bogliaco-villavetro",
      "name": "Bogliaco-Villavetro",
      "primary": true,
      "skipSearch": false
    }],
    "villavetro": [{
      "hkey": "034a9bc0",
      "slug": "bogliaco-villavetro",
      "name": "Bogliaco-Villavetro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gargnano"
    }]
  }
};
exports["default"] = _default;